import avatar from "./avatar.png";
export default {
  login: "No User",
  node_id: "",
  avatar_url: avatar,
  gravatar_id: "",
  url: "",
  html_url: "",
  followers_url: "",
  following_url: "",
  gists_url: "",
  starred_url: "",
  subscriptions_url: "",
  organizations_url: "",
  repos_url: "",
  events_url: "",
  received_events_url: "",
  type: "User",
  site_admin: false,
  name: "",
  company: "",
  blog: "",
  location: "",
  email: null,
  hireable: null,
  bio: "",
  twitter_username: " ",
  public_repos: 0,
  public_gists: 0,
  followers: 0,
  following: 0,
};
